
import low from 'lowdb'
import LocalStorage from 'lowdb/adapters/LocalStorage'

const adapter = new LocalStorage(`gmshop`)
const db = low(adapter)

// 当前时间戳
function timestamp(){
  let timestamp = Date.parse( new Date() ).toString();
  return parseInt(timestamp.substr(0,10));
}

db.defaults({
  sys: {},
  route: []
}).write()

/**
 * 设置路由
 */
db.setRoute = (e, params) => {
  let route = db.get('route');
  let path = { 'path': e.$route.path };
  // 有效时间
  if (params.valid_time&&params.valid_time>0){
    params.valid_time = parseInt(params.valid_time) + timestamp()
  }
  if (route.find(path).value()) {
    route.find(path).assign(params).write();
  } else {
    route.push(Object.assign(path, params)).write();
  }
  
}

/**
 * 取字段
 */
db.getRouteField = (e, value) => {
  let route = db.get('route');
  let path = { 'path': e.$route.path };
  // 默认
  let v = route.find(path).value();
  if (typeof v!=="undefined" && v.valid_time && v.valid_time>0 && v.valid_time<timestamp()){
    route.remove().write();
    return;
  } 
  if (v) return v[value];
}

export default db


// WEBPACK FOOTER //
// ./src/utils/db.js